var Marionette = require('marionette'),
    $ = require('jquery');

module.exports = Marionette.ItemView.extend({
    tagName: 'iframe',
    className: 'hide',
    CLOSE_TIMEOUT: 30000, /* closing prior to download will cancel request*/
    //CHECK_INTERVAL: 100,
    //COOKIE_NAME: 'FSESSIONID', //may be good to reimplement cookie: could then closing dialog on queue
    render: function() {
        var self = this;
        //setTimeout(function() {
           // self.checkForDLCompletion();
        //}, this.CHECK_INTERVAL);
        this.options.container.append(this.$el.attr('src', this.options.src));

        setTimeout(function() {
            self.destroy();
        }, this.CLOSE_TIMEOUT); //todo: try this to safe memory: the download is complete once the source is set?
        return this;
    }
    /*,
    checkForDLCompletion: function() {
        var doc = this.el.contentWindow.document,
            self = this;

        //todo: nevermind -- not getting cookie --- just try removal of frame
        if (doc.cookie.indexOf( this.COOKIE_NAME) > -1 ){

            this.dlCompleted();
            return;
        }

        //check for 'FSESSIONID'
        //FSESSIONID

        //setTimeout( self.checkForDLCompletion.call(self), self.CHECK_INTERVAL);
    },
    dlCompleted: function() {

    }
    //todo: still checking for completion?*/


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/downloadFrame.js
 ** module id = 108
 ** module chunks = 0
 **/